var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{attrs:{"id":"logo_"}},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"Logo","src":_vm.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }